import { NavContainer } from "./styles";

import { Dispatch } from "react";

import { iconMap } from "../../assets/icons";

type Props = {
  currentOpen:number;
  setCurrentOpen:Dispatch<number>;
}

const Navbar = ({ setCurrentOpen, currentOpen }:Props) => {

  const itens = [
    { name:"Converse com um corretor", icon:"house_with_hand" },
    { name:"Atendimento ao cliente", icon:"person" },
    { name:"Outros assuntos", icon:"question_mark_circle" }
  ]

  return (
    <NavContainer>
      
      { itens.map((tab, index) => (
        <button 
          className={index === currentOpen ? "active" : "" } 
          key={ tab.name } 
          onClick={ () => setCurrentOpen(index) }
        >
          <img
            alt={ tab.name }
            height={ 20 }
            src={iconMap[tab.icon!]}
            width={ 20 }
          />
          { tab.name }
        </button>
      ))}

    </NavContainer>
  )
}

export default Navbar